import LsdApiModel  from './global/LsdApiModel';
import { computed } from 'mobx';

export default class ExpensePaymentVoucherStepModel extends LsdApiModel {
	static get path(): string {
		return '/expense_payment_voucher_steps/{?id}';
	}

	@computed
	public get createdById() {
		return this.get('createdBy.id');
	}

	@computed
	public get expensePaymentVoucherId() {
		return this.get('expensePaymentVoucher.id');
	}

	@computed
	public get responsibleId() {
		return this.get('responsible.id');
	}

	@computed
	public get responsibleIri() {
		return this.get('responsible.@id');
	}

	@computed
	public get status() {
		return this.get('status');
	}
}
